import React, { Component } from 'react';
import {
  arrayOf,
  number,
  shape,
  bool,
  func,
  oneOfType,
  string,
} from 'prop-types';
import { withTranslation } from 'react-i18next';
import { graphql } from 'react-apollo';
import compose from 'lodash/flowRight';
import T from 'aegisv2/Text';
import { formatCourseV2, checkIfisInShoppingCart } from 'Catalog/utils';
import { CATALOG_TRANSLATION_KEY } from 'Jsx/Utils/transformKeys';
// import { COURSES_PAGE_SIZE } from 'Jsx/Catalog/utils';
import getCommunityNew from 'Jsx/Catalog/graphql/searchCourses.graphql';
import CourseListSlider from './CourseListSlider';

class CommunityNew extends Component {
  shouldComponentUpdate(nextProps) {
    return (
      this.props.loading !== nextProps.loading ||
      this.props.courseIdsOwned.length !== nextProps.courseIdsOwned.length ||
      this.props.loadingCartButton !== nextProps.loadingCartButton
    );
  }

  render() {
    const {
      courseIdsOwned,
      removeCourseFromCart,
      addCourseToCart,
      user,
      loading,
      courses,
      error,
      size,
      loadingCartButton,
      isOrganization,
      t,
      userLanguage,
    } = this.props;

    if (error) {
      return (
        <div style={{ padding: '24px 0', marginBottom: '0' }}>
          <T color="#09f" bold xs>
            Ocurrió un error al intentar obtener los cursos recomendados,
            intente recargar la página.
          </T>
        </div>
      );
    }

    return (
      <CourseListSlider
        courseIdsOwned={courseIdsOwned}
        removeCourseFromCart={removeCourseFromCart}
        addCourseToCart={addCourseToCart}
        skeletonItems={size}
        courses={courses}
        title={t('COURSE_NEW')}
        isUserLogged={!!user}
        user={user}
        loading={loading || typeof window === 'undefined'}
        link="/cursos-nuevos/"
        linkText={t('COURSE_WATCH_MORE')}
        loadingCartButton={loadingCartButton}
        isOrganization={isOrganization}
        name="CommunityNew"
        userLanguage={userLanguage}
      />
    );
  }
}

CommunityNew.defaultProps = {
  user: null,
  error: false,
  isOrganization: false,
};

CommunityNew.propTypes = {
  courseIdsOwned: arrayOf(number).isRequired,
  removeCourseFromCart: func.isRequired,
  addCourseToCart: func.isRequired,
  courses: arrayOf(
    shape({
      originalId: number.isRequired,
    }),
  ).isRequired,
  loading: bool.isRequired,
  user: shape({}),
  error: oneOfType([bool, shape({})]),
  size: number.isRequired,
  loadingCartButton: bool.isRequired,
  isOrganization: bool,
  userLanguage: string.isRequired,
};

export default compose(
  withTranslation(CATALOG_TRANSLATION_KEY),
  graphql(getCommunityNew, {
    name: 'data',
    options: ({ size }) => ({
      variables: {
        pageSize: size,
        newOrderBy: 'news',
      },
    }),
    props: ({
      ownProps: { courseIdsOwned },
      data: { loading, error, searchCourses },
    }) => ({
      loading,
      error,
      courses: searchCourses
        ? searchCourses.edges
            .map(e => e.node)
            .map(formatCourseV2)
            .map(checkIfisInShoppingCart(courseIdsOwned))
        : [],
    }),
  }),
)(CommunityNew);
